/**
 * component tree:
 */

import {
  Grid,
  InputAdornment,
  TextField,
  useTheme,
  alpha,
  MenuItem,
  Button,
  CircularProgress,
  Typography,
  FormControlLabel,
  Checkbox,
  Box
} from "@mui/material"
import {
  Call,
  Card,
  CardPos,
  DocumentText,
  GlobalSearch,
  Instagram,
  Location,
  Message,
  MessageText1,
  Mobile,
  Note,
  Personalcard,
  Shop,
  ShopAdd,
  ShoppingCart,
  Sms,
  Timer1,
  UserSquare,
  DocumentDownload,
  TickSquare,
  LocationTick
} from "iconsax-react"
import { FC, useState } from "react"
import { useForm } from "react-hook-form"
import axios from "../../../../lib/axios"
import { toast } from "react-toastify"
import AppStickSection from "../../../../components/AppStickSection"
import { onlyDigitsWithMaxLen } from "../../../../components/common/inputs/helper"
import { LinkedIn, Telegram, Facebook, Twitter } from "@mui/icons-material"
// import { Apple as LinkedIn, Apple as Telegram, Apple as Facebook, Apple as Twitter } from "iconsax-react"
import cellphoneValidation from "../../../../components/common/inputs/cellphoneValidation"
import mobileValidation from "../../../../components/common/inputs/mobileValidation"
import ValidationHelperText from "../../../../components/common/validation-helper-text"
import MerchantRules from "../../../../components/pages/merchant/components/merchantRules"
export interface GenuineProps {
  setConfirm: any
}

const Genuine: FC<GenuineProps> = ({ setConfirm }) => {
  /**
   * External Hooks
   * ______________________________________________________________________________
   */
  const theme = useTheme()

  /**
   * Consts and Variables
   * _______________________________________________________________________________
   */

  const [state, setState] = useState<"loading" | "error" | "done">("done")

  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm()

  /**
   * States and Effects and Hooks
   * _______________________________________________________________________________
   */

  /**
   * Methods
   * _______________________________________________________________________________
   */
  const handleMercharReq = value => {
    setState("loading")
    const data = {
      type: 1402,
      storeName: value?.storeName,
      ownerFullName: value?.ownerFullName,
      ownerNationalCode: value?.ownerNationalCode,
      ownerPhoneNumber: value?.ownerPhoneNumber,
      businessLicenseNumber: value?.businessLicenseNumber,
      telephoneNumber: value?.telephoneNumber,
      email: value?.email,
      classOfActivity: value?.classOfActivity,
      branchCount: value?.branchCount ? value?.branchCount : null,
      sellType: +value?.sellType,
      businessHistory: value?.businessHistory,
      mellatAcountNumber: value?.mellatAcountNumber,
      mellatTerminalNumber1: value?.mellatTerminalNumber1,
      mellatTerminalNumber2: value?.mellatTerminalNumber2,
      mellatTerminalNumber3: value?.mellatTerminalNumber3,
      address: value?.address,
      postalCode: value?.postalCode,
      website1: value?.website1,
      website2: value?.website2,
      website3: value?.website3,
      instagram: value?.instagram,
      facebook: value?.facebook,
      twitter: value?.twitter,
      telegram: value?.telegram,
      linkedIn: value?.linkedIn,
      megaBank: value?.megaBank,
      description: value?.description,
      trackingCode: value?.trackingCode
    }

    axios
      .post("/api/v1/merchant/addMerchantRequest", data)
      .then(response => {
        if (response?.status === 200) {
          if (response?.data?.succeed) {
            setState("done")
            setConfirm(response?.data.value)
            reset()
          } else {
            setState("error")
            toast.error(response?.data?.message)
          }
        }
      })
      .catch(() => {
        setState("error")
      })
  }

  const DownloadContractFile = () => {
    const link = document.createElement("a")
    link.href = "/jetvamContract.pdf"
    link.download = "jetvamContract.pdf"
    link.click()
  }
  const isValidEmail = email => {
    // eslint-disable-next-line no-useless-escape
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    )
  }
  const handleEmailValidation = email => {
    if (email?.length) {
      const isValid = isValidEmail(email)
      return isValid
    } else {
      return true
    }
  }
  /**
   * Template
   * _______________________________________________________________________________
   */

  return (
    <Grid>
      <form onSubmit={handleSubmit(handleMercharReq)}>
        <Grid spacing={1} gap={2} container pb='20px'>
          <MerchantRules register={register} errors={errors} />
          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"اطلاعات مالک"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='نام و نام خانوادگی مالک'
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  name='ownerFullName'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <UserSquare size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("ownerFullName", {
                    required: {
                      value: true,
                      message: "نام مالک الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.ownerFullName}
                  helperText={errors?.ownerFullName?.message as string}
                />{" "}
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='کد ملی مالک'
                  size='small'
                  fullWidth
                  name='ownerNationalCode'
                  onKeyDown={onlyDigitsWithMaxLen(10)}
                  type='number'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Personalcard size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("ownerNationalCode", {
                    required: {
                      value: true,
                      message: "کد ملی مالک الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.ownerNationalCode}
                  helperText={errors?.ownerNationalCode?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='شماره موبایل'
                  fullWidth
                  name='ownerPhoneNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(11)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Mobile size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("ownerPhoneNumber", {
                    maxLength: {
                      value: 11,
                      message: "شماره تماس باید 11 رقم باشد"
                    },
                    minLength: {
                      value: 11,
                      message: "شماره تماس باید 11 رقم باشد"
                    },
                    required: {
                      value: true,
                      message: "شماره موبایل الزامی است"
                    },
                    validate: mobileValidation
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.ownerPhoneNumber}
                  helperText={errors?.ownerPhoneNumber?.message as string}
                />{" "}
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type='number'
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Call size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='تلفن ثابت'
                  fullWidth
                  name='telephoneNumber'
                  onKeyDown={onlyDigitsWithMaxLen(11)}
                  {...register("telephoneNumber", {
                    maxLength: {
                      value: 11,
                      message: "شماره تماس باید 11 رقم باشد"
                    },
                    minLength: {
                      value: 11,
                      message: "شماره تماس باید 11 رقم باشد"
                    },
                    validate: cellphoneValidation
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.telephoneNumber}
                  helperText={errors?.telephoneNumber?.message as string}
                />{" "}
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Sms size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ maxLength: 50 }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='پست الکترونیکی'
                  fullWidth
                  name='email'
                  {...register("email", { validate: handleEmailValidation })}
                />
                <ValidationHelperText error={!!errors?.email} helperText={"آدرس ایمیل صحیح نیست"} />{" "}
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"اطلاعات کسب و کار"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  label='نام فروشگاه'
                  size='small'
                  fullWidth
                  name='storeName'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Shop size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("storeName", {
                    required: {
                      value: true,
                      message: "نام فروشگاه الزامی است"
                    }
                  })}
                />
                <ValidationHelperText error={!!errors?.storeName} helperText={errors?.storeName?.message as string} />{" "}
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='شماره پروانه کسب'
                  size='small'
                  fullWidth
                  name='businessLicenseNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <DocumentText size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("businessLicenseNumber", {
                    required: {
                      value: true,
                      message: "شماره پروانه کسب الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.businessLicenseNumber}
                  helperText={errors?.businessLicenseNumber?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  inputProps={{ maxLength: 400 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <ShoppingCart size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='صنف فعالیت'
                  fullWidth
                  name='classOfActivity'
                  {...register("classOfActivity", {
                    required: {
                      value: true,
                      message: "صنف فعالیت الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.classOfActivity}
                  helperText={errors?.classOfActivity?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  onKeyDown={onlyDigitsWithMaxLen(3)}
                  InputProps={{
                    type: "number",
                    endAdornment: (
                      <InputAdornment position='start'>
                        <ShopAdd size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='تعداد شعب'
                  type='number'
                  fullWidth
                  name='branchCount'
                  defaultValue={null}
                  {...register("branchCount")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  autoComplete='off'
                  defaultValue=''
                  label='نوع فروش'
                  fullWidth
                  name='sellType'
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("sellType")}
                  select
                >
                  <MenuItem value={1501}>حضوری</MenuItem>
                  <MenuItem value={1502}>اینترنتی</MenuItem>
                  <MenuItem value={1503}>هردو</MenuItem>
                </TextField>
                <ValidationHelperText error={!!errors?.sellType} helperText={errors?.sellType?.message as string} />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='سابقه فعالیت کسب و کار'
                  fullWidth
                  name='businessHistory'
                  inputProps={{ maxLength: 400 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Timer1 size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("businessHistory")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"اطلاعات حساب بانکی"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='شماره حساب بانک ملت '
                  fullWidth
                  name='mellatAcountNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(10)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Card size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatAcountNumber")}
                />
              </Grid>
              {/* <Grid item xs={12} md={4}>
                <TextField
                  label='مگابانک'
                  fullWidth
                  name='megaBank'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Card size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("megaBank")}
                />
                <ValidationHelperText error={errors?.megaBank} helperText={errors?.megaBank?.message} />
              </Grid> */}
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='پایانه پرداخت اول (به پرداخت ملت) '
                  fullWidth
                  name='mellatTerminalNumber1'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  type='number'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <CardPos size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatTerminalNumber1")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='پایانه پرداخت دوم (به پرداخت ملت) '
                  fullWidth
                  name='mellatTerminalNumber2'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <CardPos size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatTerminalNumber2")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='پایانه پرداخت سوم (به پرداخت ملت) '
                  fullWidth
                  name='mellatTerminalNumber3'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <CardPos size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatTerminalNumber3")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"اطلاعات محل سکونت"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <LocationTick size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='کدپستی'
                  fullWidth
                  name='postalCode'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(10)}
                  {...register("postalCode")}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Location size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='نشانی'
                  size='small'
                  fullWidth
                  multiline
                  minRows={2}
                  name='address'
                  {...register("address")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"سایت ها"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  label='آدرس سایت اول'
                  size='small'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <GlobalSearch size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  fullWidth
                  name='website1'
                  {...register("website1")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='آدرس سایت دوم'
                  fullWidth
                  name='website2'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <GlobalSearch size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("website2")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='آدرس سایت سوم'
                  size='small'
                  fullWidth
                  name='website3'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <GlobalSearch size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("website3")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"شبکه های اجتماعی"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  label='اینستاگرام'
                  size='small'
                  fullWidth
                  name='instagram'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Instagram size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("instagram")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='تلگرام'
                  fullWidth
                  size='small'
                  name='telegram'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Telegram sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("telegram")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='لینکدین'
                  size='small'
                  fullWidth
                  name='linkedIn'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <LinkedIn sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("linkedIn")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='توییتر'
                  fullWidth
                  size='small'
                  name='twitter'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Twitter sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("twitter")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='فیسبوک'
                  fullWidth
                  name='facebook'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Facebook sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("facebook")}
                />
              </Grid>
              {/* <Grid item xs={12} md={4}>
                <TextField
                  label='مگا بانک'
                  fullWidth
                  name='megaBank'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Message size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("megaBank")}
                />
              </Grid> */}
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <AppStickSection title={"توضیحات"} />
            <Grid item xs={12} md={12}>
              <TextField
                label='توضیحات'
                size='small'
                minRows={3}
                multiline
                inputProps={{ maxLength: 400 }}
                fullWidth
                name='description'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='start'>
                      <Note size={20} color={theme.palette.primary.dark} />
                    </InputAdornment>
                  )
                }}
                sx={{
                  caretColor: theme.palette.secondary.main,
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                    backgroundColor: alpha(theme.palette.grey[200], 0.5)
                  }
                }}
                {...register("description")}
              />
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto'>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Grid md={4} xs={12}>
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                  <Button
                    variant='contained'
                    size='large'
                    sx={{ borderRadius: "8px", width: "49%" }}
                    disableElevation
                    color='info'
                    fullWidth
                    onClick={DownloadContractFile}
                    endIcon={<DocumentDownload />}
                  >
                    دانلود پیش نویس قرارداد
                  </Button>
                  <Button
                    disabled={state === "loading"}
                    type='submit'
                    variant='contained'
                    size='large'
                    sx={{ borderRadius: "8px", width: "49%" }}
                    disableElevation
                    // fullWidth={deviceType === "mobile" ? true : false}
                    fullWidth
                    endIcon={<TickSquare />}
                  >
                    {state === "loading" ? <CircularProgress size={18} /> : "ثبت درخواست"}
                  </Button>
                </div>
              </Grid>
              {/* </div> */}
            </div>
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
}

export default Genuine
